export const downloadExport = {
	'fileNameFormat_NAME': 'Filename',
	'fileNameFormat_DATASOURCE_FULL': 'Full datasource path',
	'fileNameFormat_REDIRECTED_READ_URL': 'Lightly Read URL',

	'fileOutputFormat_JSON': 'json',
	'fileOutputFormat_PLAIN': 'txt',
}
export default downloadExport;